import React from 'react';
import Gravatar from 'react-gravatar';

export const MemberAvatar = props =>
    props.record ? (
    	<Gravatar email={props.record.email} size={30} style={{borderRadius: "50px"}}/>
    ) : null;

export default MemberAvatar;
